export const ADDITIONAL_ACCOUNTS_FIELD = "additionalAccountNumber";
